import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttention = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "20px",
	height: "20px",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "Group"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "+-Concept-Done",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			transform: "translate(-390.000000, -638.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-2-Copy-3",
				transform: "translate(90.000000, 583.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group",
					transform: "translate(300.000000, 55.000000)",
					children: [/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						fill: "#AC4959",
						cx: 10,
						cy: 10,
						r: 10
					}), /* @__PURE__ */ _jsx("g", {
						transform: "translate(3.750000, 3.750000)",
						fill: "#FFFFFF",
						id: "Icon/Check",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M7.16910891,9.375 L7.16910891,11.25 L5.3125,11.25 L5.3125,9.375 L7.16910891,9.375 Z M7.1875,1.25 L7.1875,8.125 L5.3125,8.125 L5.3125,1.25 L7.1875,1.25 Z",
							id: "Combined-Shape"
						})
					})]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgAttention);
export default ForwardRef;
